export const gl: Record<string, string> = {
  'nav.leagues_load_failed': 'Non se puideron cargar as túas ligas. Volve abrir o menú para tentalo de novo.',
  'api.calls_count': '{count} chamadas rexistradas',
  'api.clear': 'Limpar rexistro de chamadas',
  'api.filter_method': 'Método:',
  'api.latency': 'Latencia: {ms} ms',
  'api.latency_hint': 'Latencia simulada media: ~180ms · HTTP/2',
  'api.no_calls': 'Non hai chamadas rexistradas aínda. Realiza calquera acción no xogo.',
  'api.payload': 'Payload da Petición (Request Body):',
  'api.response': 'Resposta do Servidor (Mocked Response):',
  'api.select_hint': 'Fai clic en calquera petición da lista para ver o seu payload e resposta mockeada en formato JSON.',
  'api.status_ok': 'Estado: {status} OK',
  'api.subtitle': 'Rexistro en tempo real de chamadas simuladas á capa de servizos',
  'api.time': 'Hora: {time}',
  'api.title': 'Consola de Endpoints REST (Mock Responses)',
  'auth.authenticating': 'Autenticando no servidor...',
  'auth.demo_hint': 'Fai clic no acceso rápido para entrar como Mánager Oficial con datos precargados.',
  'auth.email': 'Correo Electrónico',
  'auth.enter_credentials': 'Introduce as túas credenciais para acceder á xestión do teu club.',
  'auth.err_email_required': 'O usuario ou correo é obrigatorio',
  'auth.err_password_required': 'O contrasinal é obrigatorio',
  'auth.feat_finance': 'Estadio, módulo comercial, préstamos e libro maior contable',
  'auth.feat_market': 'Mercado de fichaxes, cláusulas e negociación obxectiva',
  'auth.feat_squad': 'Xestión de cadro, tácticas e canteira',
  'auth.password': 'Contrasinal',
  'auth.password_required': 'O contrasinal é obrigatorio',
  'auth.quick_access': 'Acceso de Proba Rápido (1 Clic)',
  'auth.remember_me': 'Lembrar sesión',
  'auth.submit': 'Acceder á Oficina do Mánager',
  'auth.subtitle': 'Simulador de xestión deportiva profesional con motor de partidos, economía e mercado en vivo.',
  'auth.user_placeholder': 'usuario@exemplo.gal ou o teu usuario',
  'auth.user_required': 'O usuario ou correo é obrigatorio',
  'auth.welcome': 'Benvido a League of Managers',
  'auth.google_continue': 'Continuar con Google',
  'auth.google_checking': 'Comprobando a túa sesión…',
  'auth.google_err_cancelled': 'Cancelches o acceso con Google.',
  'auth.google_err_expired': 'O intento caducou ou xa se utilizou. Téntao de novo.',
  'auth.google_err_not_allowed': 'Esta conta non está habilitada para a proba con Google.',
  'auth.google_err_unavailable': 'Non se puido iniciar sesión. Téntao de novo.',
  'auth.google_back_to_login': 'Volver ao inicio de sesión',
  'auth.register_title': 'Crear Conta de Mánager',
  'auth.register_subtitle': 'Rexístrate para dirixir o teu club e competir en League of Managers.',
  'auth.register_btn': 'Crear conta',
  'auth.register_creating': 'Creando conta…',
  'auth.repeat_password': 'Confirmar Contrasinal',
  'auth.repeat_password_required': 'Debes repetir o contrasinal',
  'auth.passwords_must_match': 'Os contrasinais non coinciden',
  'auth.password_min_length': 'O contrasinal debe ter polo menos 8 caracteres',
  'auth.password_max_length': 'O contrasinal non pode superar os 128 caracteres',
  'auth.email_invalid': 'Introduce un correo electrónico válido',
  'auth.email_max_length': 'O correo non pode superar os 254 caracteres',
  'auth.register_success_title': 'Comproba o teu correo',
  'auth.register_success_neutral_msg': 'Se procede o rexistro, recibirás un correo para confirmar a túa conta; se xa tes conta, utiliza o teu método de acceso habitual.',
  'auth.resend_btn': 'Reenviar correo de confirmación',
  'auth.resend_wait': 'Reenviar en {seconds}s',
  'auth.resend_sending': 'Reenviando…',
  'auth.resend_sent': 'Se a conta está pendente de confirmación, reenviamos o correo.',
  'auth.has_account': 'Xa tes conta? Inicia sesión',
  'auth.no_account': 'Non tes conta? Rexístrate',
  'auth.err_email_not_verified': 'O teu correo electrónico aínda non foi confirmado. Revisa a túa caixa de entrada ou solicita unha nova ligazón.',
  'auth.err_invalid_request': 'Revisa os datos introducidos. O contrasinal debe ter entre 8 e 128 caracteres.',
  'auth.err_rate_limited': 'Realizaches demasiadas solicitudes. Agarda un momento antes de tentalo de novo.',
  'auth.err_unavailable': 'O servizo non está dispoñible temporalmente. Téntao máis tarde.',
  'auth.err_registration_disabled': 'O rexistro de contas non está dispoñible neste momento.',
  'auth.verify_title': 'Confirmación de Correo Electrónico',
  'auth.verify_subtitle': 'Preme o botón para activar a túa conta de mánager en League of Managers.',
  'auth.verify_btn': 'Confirmar correo',
  'auth.verify_confirming': 'Confirmando o teu correo…',
  'auth.verify_success_title': 'Correo confirmado con éxito!',
  'auth.verify_success_desc': 'A túa conta xa está activa. Xa podes iniciar sesión co teu correo e contrasinal.',
  'auth.verify_go_to_login': 'Ir a Iniciar Sesión',
  'auth.verify_err_invalid_token': 'A ligazón de confirmación é inválida, caducou ou xa foi utilizada.',
  'auth.verify_err_resend_title': 'Precisas dunha nova ligazón?',
  'auth.verify_err_resend_desc': 'Introduce o teu correo para recibir unha nova ligazón de activación.',
  'auth.verify_enter_email': 'Introduce o teu correo electrónico',
  'auth.verify_request_new_link': 'Solicitar nova ligazón',
  'auth.verify_missing_token': 'Non se proporcionou ningún token de confirmación na ligazón.',
  'club.accounting_version': 'Versión contable',
  'club.active_loans': 'activa(s)',
  'club.available_balance': 'Saldo Dispoñible en Caixa',
  'club.currency': 'Moeda',
  'club.healthy_accounts': 'Contas Saneadas',
  'club.ledger_col_amount': 'Importe',
  'club.ledger_col_balance': 'Saldo Resultante',
  'club.ledger_col_concept': 'Concepto',
  'club.ledger_col_date': 'Data',
  'club.ledger_col_origin': 'Orixe',
  'club.ledger_col_type': 'Tipo',
  'club.ledger_desc': 'Rexistro contable',
  'club.ledger_entries': 'asentos rexistrados',
  'club.ledger_expense': 'GASTO',
  'club.ledger_income': 'INGRESO',
  'club.ledger_title': 'Transaccións',
  'club.modules_synced': 'Módulos comerciais e de explotación sincronizados',
  'club.no_ledger_entries': 'Non hai asentos contables rexistrados no libro maior.',
  'club.reserved_balance': 'Garantías / Fondos Comprometidos',
  'club.solvency_desc': 'Control patrimonial oficial da entidade. As finanzas do club liquídanse estritamente en euros (€).',
  'club.solvency_title': 'Estado de Solvencia e Liquidez',
  'club.total_balance': 'Balance Total Auditado',
  'club.treasury_audited': 'Tesouraría auditada en tempo real',
  'common.all': 'Todos',
  'common.back': 'Volver',
  'common.cancel': 'Cancelar',
  'common.close': 'Pechar',
  'common.confirm': 'Confirmar',
  'common.delete': 'Eliminar',
  'common.edit': 'Modificar',
  'common.live': 'En directo',
  'common.loading': 'Cargando...',
  'common.retry': 'Reintentar',
  'common.save': 'Gardar',
  'common.today': 'Hoxe',
  'common.version': 'Versión',
  'common.yesterday': 'Onte',
  'comp.advance_round': 'Avanzar a Xornada {round}',
  'comp.badge': 'Primeira División',
  'comp.box_office': 'Recadación Billeteira',
  'comp.calendar_title': 'Calendario de Partidos',
  'comp.close': 'Pechar',
  'comp.club_col': 'Club',
  'comp.col_club': 'Club',
  'comp.col_dg': 'DG',
  'comp.col_form': 'Forma',
  'comp.col_gc': 'GC',
  'comp.col_gf': 'GF',
  'comp.col_pe': 'PE',
  'comp.col_pg': 'PG',
  'comp.col_pj': 'PX',
  'comp.col_pos': '#',
  'comp.col_pp': 'PP',
  'comp.col_pts': 'Pts',
  'comp.current_round': 'Xornada en curso:',
  'comp.final_score': 'Resultado Final',
  'comp.finished': 'REMATADA',
  'comp.form_col': 'Forma',
  'comp.goalscorers': 'Goleadores',
  'comp.group_id_prefix': 'ID de Grupo: ',
  'comp.group_label': 'Grupo',
  'comp.in_progress': 'EN XOGO',
  'comp.league_desc': 'Liga regular de 20 clubs · 38 xornadas ida e volta · 4 descensos directos.',
  'comp.legend_champions': 'Champions League',
  'comp.legend_conf': '7º Conference League',
  'comp.legend_conference': 'Conference League',
  'comp.legend_direct_promotion': 'Ascenso directo',
  'comp.legend_europa': 'Europa League',
  'comp.legend_playoff': 'Playoff de ascenso',
  'comp.legend_rel': '17-20º Descenso Directo',
  'comp.legend_relegation': 'Descenso',
  'comp.legend_ucl': '1-4º Champions League',
  'comp.legend_uel': '5-6º Europa League',
  'comp.live_standings': 'Clasificación en Vivo',
  'comp.loading_fixtures': 'Cargando partidos da xornada...',
  'comp.loading_round': 'Cargando xornada...',
  'comp.loading_standings': 'Cargando clasificación do grupo...',
  'comp.match_detail': 'Detalle de Partido',
  'comp.match_detail_title': 'Detalle do Partido',
  'comp.next_round': 'Xornada seguinte',
  'comp.no_fixtures': 'Non hai partidos programados para esta xornada.',
  'comp.official_calendar': 'Calendario oficial',
  'comp.prev_round': 'Xornada anterior',
  'comp.refresh_standings': 'Actualizar clasificación en vivo',
  'comp.round_header': 'Xornada {current} de {total}',
  'comp.round_of': 'de',
  'comp.round_prefix': 'Xornada',
  'comp.scorers': 'Goleadores',
  'comp.simulate_round': 'Simular Xornada {round}',
  'comp.spectators': 'Espectadores',
  'comp.standings_title': 'Clasificación en Vivo',
  'comp.status': 'Estado',
  'comp.subtitle': 'Liga regular de 20 clubs · 38 xornadas ida e volta · 4 descensos directos.',
  'comp.ticket_revenue': 'Recadación Taquilla',
  'comp.tiebreaker': 'Desempate: Pts · DG · GF',
  'comp.tiebreaker_legend': 'Desempate: Pts · DG · GF',
  'comp.title': 'Competición Oficial',
  'comp.you': 'TI',
  'comp.you_badge': 'TI',
  'dashboard.away': 'Visitante',
  'dashboard.away_badge': 'Rival na Liga',
  'dashboard.current_position': 'A túa posición actual: {pos}º clasificado con {pts} puntos',
  'dashboard.edit_lineup': 'Modificar Aliñación',
  'dashboard.forecast_attendance': 'Previsión de Asistencia',
  'dashboard.forecast_revenue': 'Ingresos Estimados',
  'dashboard.home': 'Local',
  'dashboard.kpi_budget': 'Orzamento para Fichaxes',
  'dashboard.kpi_budget_sub': 'Fondos dispoñibles sen comprometer',
  'dashboard.kpi_stadium': 'Capacidade do Estadio',
  'dashboard.kpi_stadium_sub': 'Capacidade actual',
  'dashboard.kpi_staff': 'Nivel Corpo Técnico',
  'dashboard.kpi_staff_sub': 'Media estrelas 4 preparadores',
  'dashboard.kpi_ticket': 'Prezo Entrada Xeral',
  'dashboard.kpi_ticket_sub': 'Fixado para a tempada',
  'dashboard.lineup_incomplete': 'Aliñación incompleta ({current}/11 seleccionados)',
  'dashboard.lineup_ready': 'Aliñación completa e lista',
  'dashboard.lineup_unavailable': 'Non se puido consultar a aliñación',
  'dashboard.local_badge': 'O Teu Club',
  'dashboard.news_count_plural': 'novas',
  'dashboard.news_count_single': 'nova',
  'dashboard.news_desc': 'Últimos movementos oficiais, traspasos confirmados e actualidade do campionato',
  'dashboard.news_empty': 'Non hai novas ou traspasos rexistrados nesta competición actualmente.',
  'dashboard.news_live': 'En directo',
  'dashboard.news_loading': 'Cargando novas e traspasos da liga...',
  'dashboard.news_title': 'Novas e Fichaxes da Liga',
  'dashboard.news_today': 'HOXE',
  'dashboard.news_view_market': 'Ver Mercado',
  'dashboard.news_yesterday': 'ONTE',
  'dashboard.next_match': 'Próximo Encontro (Xornada {round})',
  'dashboard.play_round': 'Disputar Xornada {round}',
  'dashboard.quick_finance_desc': 'Amplía bancadas, mellora módulos comerciais, contrata preparadores e xestiona liñas de crédito.',
  'dashboard.quick_finance_title': 'Estadio e Finanzas',
  'dashboard.quick_market_desc': 'Ficha axentes libres, executa cláusulas de rescisión ou pon en venda futbolistas transferibles.',
  'dashboard.quick_market_title': 'Mercado de Fichaxes',
  'dashboard.quick_squad_desc': 'Define a formación táctica (4-3-3, 4-4-2, etc.), asigna dorsais e axusta o once para o partido.',
  'dashboard.quick_squad_title': 'Cadro e Once Titular',
  'dashboard.retry': 'Reintentar',
  'dashboard.season_info': 'Tempada 2026/27 · Xornada {round} de {total}',
  'dashboard.see_results': 'Ver Resultados e Táboa',
  'dashboard.stadium_label': 'Estadio',
  'dashboard.standings_full': 'Ver táboa completa',
  'dashboard.standings_title': 'Clasificación',
  'dashboard.starters_count': 'Once Titular',
  'dashboard.status_closed': 'Pechada',
  'dashboard.status_label': 'Estado',
  'dashboard.status_locked': 'Bloqueada (Lista)',
  'dashboard.status_open': 'Aberta',
  'dashboard.status_scored': 'Disputada',
  'leagues.acronym_label': 'Acrónimo (3 letras)',
  'leagues.active_badge': 'Liga Activa',
  'leagues.active_game': 'Partida en curso',
  'leagues.cancel': 'Cancelar',
  'leagues.club_name_in_league': 'Nome do teu Club nesta Liga',
  'leagues.code_placeholder': 'Ex. PRIV-88219',
  'leagues.code_prefix': 'Código',
  'leagues.create_action': 'Crear Liga',
  'leagues.create_and_join': 'Crear Club e Unirse',
  'leagues.create_btn': 'Crear Liga Privada',
  'leagues.create_modal_title': 'Crear Nova Liga Privada',
  'leagues.create_new_league': 'Crear Nova Liga',
  'leagues.enter_club': 'Entrar ao Club',
  'leagues.enter_club_placeholder': 'Introduce o nome do teu club (ex. Burbia FC)',
  'leagues.enter_code': 'Introduce o código de invitación:',
  'leagues.enter_league': 'Entrar á Liga',
  'leagues.error_title': 'Erro ao consultar competicións',
  'leagues.global_competition': 'Competición Global',
  'leagues.global_tab': 'Ligas Globais',
  'leagues.invite_code_label': 'Código de Invitación (ex. PRIV-9872)',
  'leagues.join_action': 'Unirme',
  'leagues.join_closed': 'INSCRICIÓN PECHADA',
  'leagues.join_code_btn': 'Unirse con Código',
  'leagues.join_modal_title': 'Unirse a Liga Privada',
  'leagues.join_open': 'INSCRICIÓN ABERTA',
  'leagues.join_with_code': 'Unirse con Código',
  'leagues.league_name': 'Nome da Liga',
  'leagues.league_name_label': 'Nome da Liga',
  'leagues.main_league': 'Liga Principal',
  'leagues.managing_club': 'Estás a dirixir ao',
  'leagues.members': 'mánagers',
  'leagues.my_competitions': 'As Miñas Competicións e Ligas Activas',
  'leagues.no_private': 'Non tes ligas privadas activas actualmente. Crea unha ou únete cun código!',
  'leagues.no_private_leagues': 'Aínda non pertences a ningunha liga privada',
  'leagues.no_private_leagues_desc': 'Crea a túa propia liga de amigos para competir por xornada con normas e fichaxes propias, ou únete co código de invitación.',
  'leagues.not_available': 'Non dispoñible',
  'leagues.official_badge': 'OFICIAL',
  'leagues.official_competition': 'Competición Oficial do Sistema',
  'leagues.official_desc': 'Inscríbete na competición global creando o teu club. Competirás no sistema de divisións oficial con ascensos, descensos e ciclos competitivos.',
  'leagues.participants_count': 'Número de Participantes',
  'leagues.play_league': 'Xogar esta liga',
  'leagues.primary_color': 'Cor Principal',
  'leagues.private_disabled': 'As ligas privadas están deshabilitadas actualmente nesta temporada.',
  'leagues.private_leagues': 'Ligas Privadas con Amigos',
  'leagues.private_tab': 'Ligas Privadas',
  'leagues.registering_club': 'Rexistrando club...',
  'leagues.registrations_not_open': 'As inscricións para a competición global non están abertas neste momento.',
  'leagues.resume_game': 'Continuar Partida (Dashboard)',
  'leagues.round_of': 'Xornada {current} de {total}',
  'leagues.selection_desc': 'Selecciona a liga na que desexas competir. Cada competición xestiona de xeito illado o teu club, cadro, economía, finanzas do estadio e resultados.',
  'leagues.subtitle': 'Elixe a túa competición oficial ou accede a unha liga privada cos teus amigos.',
  'leagues.teams': 'Equipos',
  'leagues.title': 'Centro de Ligas e Competicións',
  'leagues.validate_and_enter': 'Validar Código e Entrar',
  'leagues.your_club': 'O Teu Club',
  'loans.active': 'activa(s)',
  'loans.amount_label': 'Importe do Préstamo (M€)',
  'loans.desc': 'Solicita financiamento ata un máximo de 25 M€ a un tipo de xuro fixo do 6% anual.',
  'loans.instalment': 'Cota por temporada',
  'loans.max_credit_capacity': 'Capacidade Máxima de Crédito',
  'loans.request_btn': 'Solicitar Concesión Inmediata',
  'loans.season_singular': 'Temporada',
  'loans.seasons_plural': 'Temporadas',
  'loans.term_label': 'Prazo de Amortización (Temporadas)',
  'loans.title': 'Liña de Crédito Bancario',
  'loans.total_repay': 'Total a devolver (con 6% xuro)',
  'loans.year_suffix': 'ano',
  'market.add_watchlist': 'Engadir á Carteira',
  'market.available_balance': 'Saldo Dispoñible Fichaxes',
  'market.badge': 'Mercado, Ofertas & Carteira',
  'market.balance': 'Saldo Dispoñible Fichaxes',
  'market.buyout': 'Clausulazo',
  'market.daily_bidding': 'Licitación Diaria',
  'market.closes_at': 'Peche de licitación',
  'market.cancel': 'Cancelar',
  'market.cancel_offer': 'Cancelar Oferta',
  'market.club_balance': 'Saldo Club',
  'market.contract_years': 'Duración (Anos)',
  'market.desc': 'Negociación obxectiva de contratos, estado de ofertas activas e carteira de futbolistas en seguimento.',
  'market.empty_market': 'Non se atoparon futbolistas cos filtros seleccionados.',
  'market.error_funds_reservation_rejected': 'Reserva de fondos rexeitada. Saldo insuficiente para presentar a oferta.',
  'market.error_funds_reservation_rejected_details': 'Saldo insuficiente para presentar a oferta. Necesitas {requestedAmount} e tes {availableAmount} dispoñibles.',
  'market.error_insufficient_funds': 'Saldo insuficiente para presentar a oferta. Necesitas {requestedAmount} e tes {availableAmount} dispoñibles.',
  'market.eval_accept': 'O futbolista aceptará esta proposta',
  'market.eval_reject': 'Proposta insuficiente para o xogador',
  'market.filter_all': 'Todos',
  'market.filter_att': 'DIA',
  'market.filter_def': 'DEF',
  'market.filter_gk': 'POR',
  'market.filter_mid': 'MED',
  'market.free_badge': 'Axente Libre',
  'market.loading_agents': 'cargando...',
  'market.modal_edit_title': 'Modificar Oferta Activa por {name}',
  'market.modal_title': 'Proposta de Contrato a {name}',
  'market.negotiate': 'Negociar Contrato',
  'market.no_offers': 'Non tes ofertas activas de traspaso neste momento.',
  'market.no_watchlist': 'A túa carteira de seguimento está baleira. Marca futbolistas coa icona de marcador para seguelos.',
  'market.offered_clause': 'Nova Cláusula de Rescisión (M€)',
  'market.offered_salary': 'Ficha Anual Proposta (M€)',
  'market.offers_all': 'Todas as Ofertas',
  'market.offers_market_targets': 'Obxectivos de Mercado',
  'market.offers_sent': 'As Miñas Ofertas Emitidas',
  'market.only_free': 'Só Libres',
  'market.remove_sale': 'Retirar de Transferibles',
  'market.remove_watchlist': 'Quitar da Carteira',
  'market.required_funds': 'Custo Inicial Total',
  'market.search_placeholder': 'Buscar futbolista...',
  'market.signing_bonus': 'Prima de Fichaxe (M€)',
  'market.submit_offer': 'Formalizar Oferta',
  'market.subtab_active_offers': 'Ofertas Activas',
  'market.subtab_history_offers': 'Historial de Ofertas',
  'market.history_title': 'Historial de Poxas por Xogadores Libres',
  'market.history_desc': 'Rexistro histórico de ofertas presentadas, resolucións de poxas e ofertas gañadas ou perdidas.',
  'market.history_filter_all': 'Todas as Ofertas',
  'market.history_filter_won': 'Gañadas',
  'market.history_filter_lost': 'Perdidas',
  'market.history_filter_cancelled': 'Canceladas',
  'market.history_won_badge': 'Fichaxe Gañada',
  'market.history_lost_badge': 'Superada',
  'market.history_cancelled_badge': 'Oferta Cancelada',
  'market.rejection_reason_title': 'Motivo do rexeitamento',
  'market.rejection_reason_ACCEPTED_OTHER_CLUB': 'Aceptou a oferta doutro club',
  'market.rejection_reason_RELEASE_CLAUSE_TOO_HIGH': 'Cláusula de rescisión demasiado alta',
  'market.rejection_reason_ECONOMIC_OFFER_TOO_LOW': 'Oferta económica insuficiente',
  'market.history_empty': 'Non se atoparon ofertas no historial cos criterios seleccionados.',
  'market.history_total_won': 'Fichaxes Gañadas',
  'market.history_total_lost': 'Ofertas Perdidas',
  'market.history_total_cancelled': 'Canceladas',
  'market.history_total_invested': 'Investimento Gañado',
  'market.history_search_placeholder': 'Filtrar por nome de futbolista...',
  'market.subtab_market': 'Mercado',
  'market.subtab_my_sales': 'Os Meus Transferibles',
  'market.subtitle': 'Negociación obxectiva de contratos e cláusulas de rescisión con control de fondos.',
  'market.tab_market': 'Xogadores',
  'market.tab_offers': 'Ofertas',
  'market.tab_watchlist': 'Carteira',
  'market.title': 'Mercado de Fichaxes e Contratacións',
  'market.transfer_fee': 'Prezo de Traspaso ao Club (M€)',
  'market.transfer_offer': 'Oferta Formal',
  'market.update_offer': 'Gardar Cambios',
  'match.away': 'Visitante',
  'match.badge': 'Simulación de Partidos',
  'match.batch_notice': 'Xestión batch automatizada no backend',
  'match.col_goals': 'Goles',
  'match.col_player': 'Futbolista',
  'match.col_points': 'Puntos Fantasy',
  'match.col_pos': 'Pos',
  'match.col_reds': 'Vermellas',
  'match.col_stars': 'Estrelas Prensa (1-5★)',
  'match.col_yellows': 'Amarelas',
  'match.cycle_title': 'Fases do Ciclo de Xornada',
  'match.editorial_desc': 'Puntuacións oficiais (1-5 estrelas) e eventos para calcular os puntos fantasy.',
  'match.editorial_title': 'Panel Editorial de Prensa Deportiva',
  'match.home': 'Local',
  'match.match_attendance': 'Asistencia Rexistrada:',
  'match.match_goals': 'Goles do Partido:',
  'match.mod_attendance': 'Presión Ambiental / Capacidade Local',
  'match.mod_attendance_desc': 'Bonus por porcentaxe de ocupación do estadio',
  'match.mod_momentum': 'Inercia Positiva (Momentum)',
  'match.mod_momentum_desc': 'Racha de vitorias nos últimos 5 partidos',
  'match.mod_staff': 'Preparación de Staff Técnico',
  'match.mod_staff_desc': 'Media de estrelas do corpo técnico',
  'match.next_btn': 'Avanzar á Seguinte Xornada',
  'match.not_sent_off': 'Non',
  'match.phase1_desc': 'Aliñación Aberta',
  'match.phase2_desc': 'XI Conxelado',
  'match.phase3_desc': 'Puntos Calculados',
  'match.phase4_desc': 'Xornada Pechada',
  'match.publish_btn': 'Publicar Cualificacións Oficiais',
  'match.sent_off': 'Expulsado',
  'match.simulate_btn': 'Calcular e Simular Xornada {round}',
  'match.subtitle': 'Ciclo de xornada: PLANNED → OPEN → LOCKED → SCORED → CLOSED. Rendemento deportivo.',
  'match.tab_editorial': 'Cualificacións de Prensa',
  'match.tab_engine': 'Modificadores de Rendemento',
  'match.tactical_desc': 'Cálculo de factores multiplicadores aplicados polo motor de simulación.',
  'match.tactical_title': 'Modificadores Tácticos e de Rendemento',
  'match.ticket_revenue': 'Recadación de Billeteira:',
  'match.title': 'Centro de Xornada & Match Engine',
  'match.user_fixture_title': 'Encontro do Teu Club na Xornada {round}',
  'matches.away_label': 'Visitante',
  'matches.batch_info': 'Xestión batch automatizada no backend',
  'matches.col_fantasy_pts': 'Puntos Fantasy',
  'matches.col_goals': 'Goles',
  'matches.col_player': 'Futbolista',
  'matches.col_pos': 'Pos',
  'matches.col_press_stars': 'Estrelas Prensa (1-5★)',
  'matches.col_reds': 'Vermellas',
  'matches.col_yellows': 'Amarelas',
  'matches.desc': 'Ciclo de xornada: PLANNED → OPEN → LOCKED → SCORED → CLOSED. Backoffice de rendemento deportivo e puntuacións.',
  'matches.editorial_desc': 'Puntuacións oficiais (1-5 estrelas) e eventos para calcular os puntos fantasy da xornada.',
  'matches.editorial_title': 'Panel Editorial de Prensa Deportiva',
  'matches.home_label': 'Local',
  'matches.lineup_frozen': 'XI Conxelado',
  'matches.lineup_open': 'Aliñación Aberta',
  'matches.match_goals': 'Goles do Partido',
  'matches.mod_attendance': 'Presión Ambiental / Aforo Local',
  'matches.mod_attendance_desc': 'Bonificación por porcentaxe de ocupación do estadio',
  'matches.mod_momentum': 'Inercia Positiva (Momentum)',
  'matches.mod_momentum_desc': 'Racha de vitorias nos últimos 5 partidos',
  'matches.mod_staff': 'Preparación do Cadro Técnico',
  'matches.mod_staff_desc': 'Media de estrelas do cadro técnico',
  'matches.not_sent_off': 'Non',
  'matches.performance_mods': 'Modificadores de Rendemento',
  'matches.phase': 'Fase',
  'matches.phases_title': 'Fases do Ciclo de Xornada',
  'matches.points_calculated': 'Puntos Calculados',
  'matches.press_ratings': 'Cualificacións de Prensa',
  'matches.publish_ratings': 'Publicar Cualificacións Oficiais',
  'matches.recorded_attendance': 'Asistencia Rexistrada',
  'matches.round_closed': 'Xornada Pechada',
  'matches.sent_off': 'Expulsado',
  'matches.simulation_badge': 'Simulación de Partidos',
  'matches.spectators_suffix': 'espectadores',
  'matches.tactical_mods_desc': 'Cálculo de factores multiplicadores aplicados polo motor de simulación para o vindeiro encontro.',
  'matches.tactical_mods_title': 'Modificadores Tácticos e de Rendemento',
  'matches.ticket_collection': 'Recadación de Taquilla',
  'matches.title': 'Centro de Xornada & Match Engine',
  'matches.user_fixture_title': 'Encontro do Teu Club na Xornada',
  'nav.all_leagues': 'Ver todas / Unirse a outra liga...',
  'nav.api': 'API',
  'nav.budget': 'Orzamento',
  'nav.club': 'Club',
  'nav.news': 'Novas',
  'nav.competition': 'Competición',
  'nav.competition_context': 'Contexto de Competición',
  'nav.credits': 'Créditos (CR)',
  'nav.dark_mode_enabled': 'Modo Escuro activado',
  'nav.dark_mode_title': 'Modo Escuro / Claro',
  'nav.dashboard': 'Dashboard',
  'nav.language': 'Idioma',
  'nav.light_mode_enabled': 'Modo Claro activado',
  'nav.logout': 'Pechar Sesión',
  'nav.market': 'Mercado',
  'nav.matchengine': 'Xornada',
  'nav.next_matchday': 'Avanzar a X{round}',
  'nav.settings': 'Axustes',
  'nav.simulate': 'Simular X{round}',
  'nav.squad': 'Cadro',
  'nav.stadium': 'Club',
  'nav.switch_league': 'Cambiar de liga',
  'nav.toggle_theme_dark': 'Modo Escuro',
  'nav.toggle_theme_light': 'Modo Claro',
  'settings.lang_desc': 'Dispoñible nos 4 idiomas oficiais (Español, Català, Galego e Euskara).',
  'settings.lang_title': 'Seleccionar Idioma da Plataforma',
  'settings.notifications_desc': 'Visualizar avisos informativos e de éxito (se se desactiva, só se amosarán erros).',
  'settings.notifications_disabled': 'Só Erros',
  'settings.notifications_enabled': 'Activadas',
  'settings.notifications_title': 'Notificacións do Sistema',
  'settings.profile_club': 'Club Actual Asignado',
  'settings.profile_desc': 'Datos da conta de usuario e credenciais de acceso.',
  'settings.profile_email': 'Correo de Contacto',
  'settings.profile_info': 'Información do Mánager',
  'settings.profile_logout': 'Pechar Sesión Oficial',
  'settings.profile_name': 'Nome Oficial',
  'settings.profile_role': 'Rol no Sistema',
  'settings.profile_version': 'Versión da Plataforma',
  'settings.separation_desc': 'A tesouraría do club está completamente desvinculada dos créditos de usuario. O teu Wallet persoal de créditos (CR) adminístrase de forma independente en Axustes.',
  'settings.separation_title': 'Separación de Fondos',
  'settings.subtitle': 'Configuración, preferencias e Wallet de créditos persoais',
  'settings.tab_preferences': 'Preferencias',
  'settings.tab_profile': 'Perfil',
  'settings.tab_wallet': 'Wallet (CR)',
  'settings.theme_dark': 'Modo Escuro (Noite)',
  'settings.theme_desc': 'Alterna entre o modo claro e o modo escuro optimizado para baixa luminosidade.',
  'settings.theme_light': 'Modo Claro (Día)',
  'settings.theme_title': 'Tema Visual da Aplicación',
  'settings.title': 'Axustes do Mánager',
  'shield.customize': 'Personalizar escudo',
  'shield.title': 'Personalización do escudo',
  'shield.subtitle': 'Deseño vectorial, cores e iniciais do club',
  'settings.wallet_balance': 'Saldo no Wallet',
  'settings.wallet_benefit_analytics': 'Módulos analíticos avanzados',
  'settings.wallet_benefit_fee': 'Licenza federativa mensual',
  'settings.wallet_benefit_leagues': 'Ligas VIP entre mánagers',
  'settings.wallet_best_value': 'Mellor Valor',
  'settings.wallet_desc': 'Créditos persoais de mánager independentes da tesouraría do club.',
  'settings.wallet_explanation': 'Os créditos (CR) pertencen á túa conta persoal e non se mesturan cos fondos nin o orzamento do club.',
  'settings.wallet_monthly_fee': 'Cota mensual de licenza',
  'settings.wallet_open': 'Xestionar Wallet',
  'settings.wallet_pay_fee': 'Abonar Cota Mensual (-100 CR)',
  'settings.wallet_personal_funds': 'Fondos Persoais',
  'settings.wallet_popular': 'Popular',
  'settings.wallet_recharge': 'Recargar Créditos',
  'settings.wallet_recharge_btn': 'Recargar {cr} CR',
  'settings.wallet_recharge_instant': 'Recarga inmediata ao moedeiro',
  'settings.wallet_title': 'Wallet do Mánager (CR)',
  'squad.age': 'anos',
  'squad.auto_pick': 'Auto Once',
  'squad.badge_management': 'Xestión de Once',
  'squad.cancel': 'Cancelar',
  'squad.clause': 'Cláusula',
  'squad.col_actions': 'Accións',
  'squad.col_age': 'Idade',
  'squad.col_clause': 'Cláusula',
  'squad.col_number': '#',
  'squad.col_ovr': 'OVR',
  'squad.col_player': 'Futbolista',
  'squad.col_pos': 'Pos',
  'squad.col_salary': 'Ficha',
  'squad.col_status': 'Estado',
  'squad.confirm_renew': 'Confirmar Renovación',
  'squad.desc': 'Exactamente 11 titulares para a Xornada. Sen substitucións en directo.',
  'squad.formation': 'Formación',
  'squad.lock_xi': 'Bloquear XI',
  'squad.locked_xi': 'XI Bloqueado',
  'squad.new_clause': 'Nova Cláusula (M€)',
  'squad.new_salary': 'Nova Ficha Anual (M€)',
  'squad.new_years': 'Anos de Contrato',
  'squad.ovr': 'Media OVR',
  'squad.pos_def': 'Defensa',
  'squad.pos_del': 'Dianteiro',
  'squad.pos_df': 'DEF',
  'squad.pos_fw': 'DIA',
  'squad.pos_gk': 'POR',
  'squad.pos_med': 'Centrocampista',
  'squad.pos_mf': 'MED',
  'squad.pos_por': 'Porteiro',
  'squad.put_transferable': 'Pór en venda',
  'squad.remove_transferable': 'Retirar de venda',
  'squad.renew_contract': 'Renovar Contrato',
  'squad.renew_modal_title': 'Renovación de Contrato',
  'squad.salary': 'Ficha Anual',
  'squad.save_lineup': 'Gardar',
  'squad.saved': 'Gardado',
  'squad.saving': 'Gardando...',
  'squad.starters_count': 'Titulares',
  'squad.starting_xi': 'Once Titular ({count}/11)',
  'squad.substitutes': 'Banquiño e Reservas ({count})',
  'squad.subtitle': 'Configura a túa táctica, formación e aliñación para a próxima xornada.',
  'squad.tactical_board': 'Formación',
  'squad.title': 'Cadro e Táctica',
  'squad.transfer_status': 'Estado',
  'squad.transferable': 'Transferible',
  'squad.years': 'anos',
  'stadium.attendance_sim_note': 'Estimación segundo o prezo e as instalacións actuais, con clasificación neutral. Os ingresos comerciais usan tarifas orientativas; o resultado real pode variar.',
  'stadium.attendance_sim_title': 'Simulación de Aforo Previsto',
  'stadium.badge': 'Infraestrutura & Finanzas',
  'stadium.cafeteria_desc': 'Aumenta as vendas de comida e bebida durante os descansos.',
  'stadium.cafeteria_title': 'Cafetarías & Hostalaría',
  'stadium.capacity_desc': 'Aumenta a capacidade do estadio para xerar maiores ingresos na billeteira.',
  'stadium.capacity_label': 'Aforo',
  'stadium.capacity_title': 'Ampliación de Bancadas e Capacidade',
  'stadium.capacity_upgrade_title': 'Ampliación de Bancadas e Aforo',
  'stadium.commercial_modules_title': 'Módulos Comerciais e Explotación',
  'stadium.confirm_pricing': 'Confirmar Prezos para o Vindeiro Partido',
  'stadium.confirm_tickets': 'Confirmar Prezos para o Próximo Partido',
  'stadium.current': 'Actual',
  'stadium.current_tier': 'Capacidade Vixente',
  'stadium.desc': 'Prezos, capacidade, módulos comerciais, corpo técnico, créditos bancarios e libro maior (Ledger).',
  'stadium.economy_tier': 'Económico',
  'stadium.est_attendance': 'Ocupación Estimada:',
  'stadium.expense': 'GASTO',
  'stadium.general_ticket': 'Prezo Entrada Xeral',
  'stadium.general_ticket_price': 'Prezo Entrada Xeral',
  'stadium.income': 'INGRESO',
  'stadium.ledger_amount': 'Importe',
  'stadium.ledger_balance': 'Saldo Resultante',
  'stadium.ledger_concept': 'Concepto',
  'stadium.ledger_date': 'Data',
  'stadium.ledger_desc': 'Rexistro contable',
  'stadium.ledger_entries': '{count} apuntamentos rexistrados',
  'stadium.ledger_title': 'Transaccións',
  'stadium.ledger_type': 'Tipo',
  'stadium.level': 'Nivel',
  'stadium.loan_amount': 'Importe do Préstamo (M€)',
  'stadium.loan_apply': 'Solicitar Concesión Inmediata',
  'stadium.loan_desc': 'Solicita financiamento ata un máximo de 25 M€ a un tipo de xuro fixo do 6% anual.',
  'stadium.loan_installment': 'Cota por tempada:',
  'stadium.loan_title': 'Liña de Crédito Bancario',
  'stadium.loan_total': 'Total a devolver (con 6% xuro):',
  'stadium.loan_years': 'Prazo de Amortización (Tempadas)',
  'stadium.max_level': 'Nivel Máximo',
  'stadium.merchandising_desc': 'Venda de camisetas e bufandas oficiais en días de partido.',
  'stadium.merchandising_title': 'Tendas Oficiais',
  'stadium.mod_cafeteria': 'Cafetarías & Hostalaría',
  'stadium.mod_level': 'Nivel {level}/5',
  'stadium.mod_max': 'Nivel Máximo',
  'stadium.mod_merch': 'Tendas Oficiais',
  'stadium.mod_parking': 'Aparcadoiro Estadio',
  'stadium.modules_desc': 'Mellora as instalacións comerciais para incrementar os ingresos por afeccionado en cada partido.',
  'stadium.modules_title': 'Módulos Comerciais e Explotación',
  'stadium.parking_desc': 'Mellora o ingreso por asento e a comodidade dos siareiros.',
  'stadium.parking_title': 'Aparcadoiro Estadio',
  'stadium.passed_tier': 'Superado',
  'stadium.premium_tier': 'Premium',
  'stadium.pricing_desc': 'Axusta o prezo medio das entradas xerais para optimizar a taquilla segundo a demanda e o momento do equipo.',
  'stadium.pricing_title': 'Fixación de Prezos de Entradas',
  'stadium.proj_commercial': 'Ingresos Comerciais (Aparcadoiro/Bar):',
  'stadium.proj_tickets': 'Ingresos Billeteira Proxectados:',
  'stadium.projected_commercial': 'Ingresos Comerciais (Aparcadoiro/Bar)',
  'stadium.projected_tickets': 'Ingresos Taquilla Proxectados',
  'stadium.reserved_funds': 'Fondo Reservado',
  'stadium.seats': 'Asentos',
  'stadium.sim_title': 'Simulación de Capacidade Prevista',
  'stadium.staff_desc': 'Cada área de preparación incrementa o rendemento do equipo no motor de partido.',
  'stadium.staff_fitness': 'Adestrador de Defensas',
  'stadium.staff_gk': 'Adestrador Porteiros',
  'stadium.staff_shooting': 'Adestrador de Dianteiros',
  'stadium.staff_tech': 'Adestrador de Centrocampistas',
  'stadium.staff_title': 'Corpo Técnico e Preparadores',
  'stadium.staff_upgrade': '+0.5★ (0.5 M€)',
  'stadium.standard_tier': 'Estándar',
  'stadium.stands_level': 'Bancadas Nivel',
  'stadium.sub_balance': 'Saldo Actual de Créditos:',
  'stadium.sub_cost': 'Custo Cota Mensual:',
  'stadium.sub_desc': 'Xestión de cota mensual e créditos para partidas e simulacións avanzadas.',
  'stadium.sub_pay': 'Abonar Cota Mensual (-100 CR)',
  'stadium.sub_title': 'Subscrición e Créditos (CR)',
  'stadium.subtitle': 'Prezos, capacidade, módulos comerciais, corpo técnico, créditos bancarios e libro maior.',
  'stadium.surpassed_tier': 'Superado',
  'stadium.sync_server': 'Sincronizar datos co servidor',
  'stadium.tab_economy': 'Economía',
  'stadium.tab_stadium': 'Estadio',
  'stadium.tab_staff': 'Staff',
  'stadium.ticket_desc': 'Axusta o prezo medio das entradas xerais para optimizar a billeteira segundo a demanda e a forma do equipo.',
  'stadium.ticket_title': 'Fixación de Prezos de Entradas',
  'stadium.title': 'Estadio e Infraestrutura Financeira',
  'stadium.total_capacity': 'Capacidade Total do Estadio:',
  'stadium.treasury': 'Tesouraría Club (EUR)',
  'stadium.upgrade_btn': 'Ampliar',
  'stadium.upgrade_level_btn': 'Mellorar Nivel',
  'stadium.upgrade_module': 'Mellorar Nivel ({cost} M€)',
  'staff.annual_cost': 'Coste Anual',
  'staff.desc': 'Cadro técnico oficial e preparadores especializados que potencian o rendemento competitivo do club.',
  'staff.fitness_coach': 'Adestrador de Defensas',
  'staff.goalkeeping_coach': 'Adestrador de Porteiros',
  'staff.modifier': 'Modificador',
  'staff.on_payroll': 'preparadores en nómina',
  'staff.quality_level': 'Nivel / Calidade',
  'staff.shooting_coach': 'Adestrador de Dianteiros',
  'staff.tactical_coach': 'Adestrador de Centrocampistas',
  'staff.title': 'Cadro Técnico e Preparadores',

  // Coaches (Adestradores)
  'coaches.title': 'Adestradores',
  'coaches.tab_market': 'Mercado de Adestradores',
  'coaches.tab_my_coach': 'O Meu Adestrador',
  'coaches.tab_offers': 'Ofertas Presentadas',
  'coaches.daily_market': 'Mercado Diario de Adestradores',
  'coaches.daily_market_desc': 'Técnicos libres dispoñibles hoxe para poxar polos seus servizos e mellorar as liñas do equipo.',
  'coaches.closes_at': 'Peche de licitación',
  'coaches.time_left': 'Tempo restante',
  'coaches.closed': 'Mercado Pechado (procesando adxudicación)',
  'coaches.empty_market': 'Non hai adestradores dispoñibles no mercado hoxe',
  'coaches.empty_market_desc': 'O mercado non dispón de máis técnicos libres para esta xornada. A selección renovarase na vindeira data.',
  'coaches.attack': 'Ataque',
  'coaches.midfield': 'Control',
  'coaches.defense': 'Defensa',
  'coaches.bonus_sum_info': 'As melloras tácticas suman exactamente un 15% entre as tres liñas do equipo.',
  'coaches.submit_offer': 'Presentar Oferta',
  'coaches.modify_offer': 'Modificar Oferta',
  'coaches.cancel_offer': 'Cancelar Oferta',
  'coaches.has_pending_offer': 'Tes unha oferta activa por este técnico',
  'coaches.offer_modal_title': 'Ofertar por Adestrador',
  'coaches.signing_bonus': 'Prima de Fichaxe (€)',
  'coaches.annual_salary': 'Salario de Tempada (€)',
  'coaches.release_clause': 'Cláusula de Rescisión (€)',
  'coaches.score': 'Puntuación',
  'coaches.score_formula': 'Puntuación = Prima × 60% + Salario × 40%',
  'coaches.score_explanation': 'Gaña a maior puntuación entre os clubs licitadores. En caso de empate, prevalece a primeira recibida.',
  'coaches.disclaimer_bonus': 'A prima cobrarase ao adxudicar a fichaxe; enviar a oferta non reserva saldo nin garante a contratación.',
  'coaches.disclaimer_salary': 'O salario cobrarase prorrateado entre as xornadas restantes da tempada ao peche de cada unha.',
  'coaches.disclaimer_replacement': 'Aviso de substitución: se gañas a poxa e xa tes adestrador contratado, o seu contrato quedará rescindido e indemnizarás as súas xornadas pendentes.',
  'coaches.disclaimer_multiple': 'Só podes ter unha oferta de adestrador activa por club e liga. Para cambiala, cancélaa antes do peche e presenta outra; perderás a prioridade de chegada orixinal.',
  'coaches.offers_unverified': 'Non podes poxar ata verificar as túas ofertas.',
  'coaches.retry': 'Reintentar',
  'coaches.checking_offers': 'Comprobando ofertas activas…',
  'coaches.uncertain_offer': 'Non se puido confirmar o envío. Reintenta a mesma oferta cos mesmos importes antes de presentar outra.',
  'coaches.active_offer': 'Xa tes unha oferta activa',
  'coaches.awaiting_resolution': 'Pendente de resolución: non podes cancelar nin presentar outra oferta ata que se resolva.',
  'coaches.cancel_before_new': 'Para cambiar de adestrador ou modificar os importes, cancela primeiro esta oferta antes do peche.',
  'coaches.view_offer': 'Ver oferta activa',
  'coaches.status_pending': 'Pendente',
  'coaches.status_won': 'Adxudicada',
  'coaches.status_lost': 'Non adxudicada',
  'coaches.status_insufficient_funds': 'Saldo insuficiente',
  'coaches.status_cancelled': 'Cancelada',
  'coaches.active_coach': 'Adestrador do Club',
  'coaches.active_coach_desc': 'Condicións contractuais e bonificacións tácticas aplicadas ao teu equipo.',
  'coaches.no_active_coach': 'Sen adestrador contratado',
  'coaches.no_active_coach_desc': 'O teu club non conta con adestrador activo. As liñas do equipo renden con mellora neutral (+0%).',
  'coaches.contract_history': 'Historial de Contratos',
  'coaches.contract_active': 'Vixente',
  'coaches.contract_terminated': 'Rescindido',
  'coaches.contract_expired': 'Vencido',
  'coaches.go_to_market': 'Fichar no Mercado de Adestradores',
  'coaches.ledger_signing_bonus': 'Prima de fichaxe de adestrador',
  'coaches.ledger_termination': 'Indemnización por despedimento de adestrador',
  'coaches.ledger_salary': 'Salario de adestrador',
  'coaches.match_frozen_notice': 'O adestrador queda conxelado ao inicio da xornada.',
  'coaches.match_included_notice': 'As potencias calculadas polo motor xa incorporan a mellora deste adestrador.',
};
